import React from 'react';
import PropTypes from 'prop-types';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import {
  FDContentContainer,
  FDLabelText,
  FDPrimaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride(['incomeTaxDisclaimer'], {
    _component: () => FDLabelText,
  }, { ordinal: 200 });

function EstimatedTaxesLayout() {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  return (
    <FDContentContainer maxWidth="sm">
      <FDStack direction="column" alignItems="stretch" spacing={2}>
        <MetaControlField attr="incomeTaxDisclaimer" />
        <FDStack direction="column" alignItems="stretch" spacing={1}>
          <MetaControlField attr="useAutoUpdateFederalTaxRate" />
          <MetaControlField attr="effectiveIncomeFederalTaxRatePercentage" />
        </FDStack>
        <MetaControlField attr="effectiveIncomeStateTaxRatePercentage" />
        <FDStack alignItems="center">
          {resource.meta().canSubmit()
            && <FDPrimaryActionButton
              test="facet-plan-save-available-resources-estimated-taxes"
              label="Save"
              loading={saving}
              onClick={onSubmit}
            />
          }
        </FDStack>
      </FDStack>
    </FDContentContainer>
  );
}

const EstimatedTaxesSection = ({
  resource: availableResourcesResource,
}) => {
  const { refreshPageContentCollection } = usePageContentContext();
  const onSubmit = () => {
    refreshPageContentCollection();
  };

  if (!availableResourcesResource) {
    return null;
  }

  const res = availableResourcesResource
    .attr('estimatedTaxes').resources().head();

  if (!res) {
    return null;
  }

  return (
    <MetaFormInline
      padding="none"
      noIndividualSubmitButtons
      layout={EstimatedTaxesLayout}
      resource={res}
      metaOverrideSet={metaOverrideSet}
      onSubmit={onSubmit}
    />
  );
};

EstimatedTaxesSection.defaultProps = {};

EstimatedTaxesSection.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default EstimatedTaxesSection;
